
export const GetCustomerCreditInfo = (api, custId, custNip, siteId) => {
    const tmpSiteId = siteId ? siteId : ''
    return api.get(`/api/v1/Customer/getCustomerCreditInfo?custId=${custId}&custNip=${custNip}&siteId=${tmpSiteId}`)
}

export const AddTaskForSendPriceList = (api, custId) => {
    return api.get(`/api/v1/Customer/AddTaskForSendPriceList?custId=${custId}`)
}

export const CheckUnfinishedTaskForSendPriceList = (api, custId) => {
    return api.get(`/api/v1/Customer/checkUnfinishedTaskForSendPriceList?custId=${custId}`)
}

export const SendPriceListViaEmail = (api, productFilter) => {
    return api.post(`/api/v1/Customer/SendPriceListViaEmail`, productFilter)
}

export const GetDeliveryAddresses = (api, custId, addMainCompanyAddress) => {
    addMainCompanyAddress = addMainCompanyAddress ? true : false
    return api.get(`/api/v1/Customer/GetDeliveryAddresses?custId=${custId}&addMainCompanyAddress=${addMainCompanyAddress}`)
}

export const AddDeliveryAddress = (api, id, name, zipCode, city, street, phoneNumber, email, expirationDate) => {
    var data = {
        Id: id,
        Name: name,
        ZipCode: zipCode,
        City: city,
        Street: street,
        PhoneNumber: phoneNumber,
        Email: email,
        EffectiveDate: expirationDate === "" ? null : expirationDate
    }
    return api.post(`/api/v1/Customer/AddDeliveryAddress`, data)
}

export const GetPeopleAuthorizedToCollectDelivery = (api, custId) => {
    return api.get(`/api/v1/Customer/getPeopleAuthorizedToCollectDelivery?custId=${custId}`)
}

export const AddPersonAuthorizedToCollectDelivery = (api, custId, name, surname, position, phoneNumber, email, expirationDate) => {
    var data = {
        CustId: custId,
        Name: name,
        Surname: surname,
        Position: position,
        ZipCode: '',
        City: '',
        Street: '',
        HouseNum: '',
        LocalNum: '',
        PhoneNumber: phoneNumber,
        Email: email,
        EffectiveDate: expirationDate === "" ? null : expirationDate
    }
    return api.post(`/api/v1/Customer/addPersonAuthorizedToCollectDelivery`, data)
}

export const DeleteDeliveryAddress = (api, recNo) => {
    return api.delete(`/api/v1/Customer/deleteDeliveryAddress?recNo=${recNo}`)
}

export const SetDeliveryAddressAsMain = (api, recNo) => {
    return api.delete(`/api/v1/Customer/setDeliveryAddressAsMain?recNo=${recNo}`)
}

export const DeletePersonAuthorizedToCollectDelivery = (api, recNo) => {
    return api.delete(`/api/v1/Customer/deletePersonAuthorizedToCollectDelivery?recNo=${recNo}`)
}

export const AddTaskForSendPriceListNow = (api, custId) => {
    return api.get(`/api/v1/Customer/AddTaskForSendPriceListNow?custId=${custId}`)
}

export const UpdatePersonAuthorizedToCollectDelivery = (api, custId, name, surname, position, phoneNumber, email, recNo, expirationDate) => {
    var data = {
        CustId: custId,
        Name: name,
        Surname: surname,
        Position: position,
        ZipCode: '',
        City: '',
        Street: '',
        HouseNum: '',
        LocalNum: '',
        PhoneNumber: phoneNumber,
        Email: email,
        RecNo: recNo,
        EffectiveDate: expirationDate === "" ? null : expirationDate
    }
    return api.post(`/api/v1/Customer/updatePersonAuthorizedToCollectDelivery`, data)
}

export const UpdateDeliveryAddress = (api, id, name, zipCode, city, street, phoneNumber, email, expirationDate, recNo) => {
    var data = {
        Id: id,
        Name: name,
        ZipCode: zipCode,
        City: city,
        Street: street,
        PhoneNumber: phoneNumber,
        Email: email,
        RecNo: recNo,
        EffectiveDate: expirationDate === "" ? null : expirationDate
    }
    return api.post(`/api/v1/Customer/updateDeliveryAddress`, data)
}

export const AddPersonAuthorizedToReceiveEInvoices = (api, email, custId) => {
    var data = {
        CustId: custId,
        Email: email,
        RecNo: -1,
    }
    return api.post(`/api/v1/Customer/addPersonAuthorizedToReceiveEInvoices`, data)
}

export const GetCustomersWithActiveBasket = (api, cancelToken) => {
    return api.get(`/api/v1/Customer/getCustomersWithActiveBasket`, { cancelToken: cancelToken })
}

export const GetCustomer = (api, custId) => {
    return api.get(`/api/v1/Customer/getCustomer?custId=${custId}`)
}

export const GetCrmEventTypes = (api, custId) => {
    const params = custId != null ? { custId } : {}
    return api.get('/api/v1/Customer/getCrmEventTypes', { params })
}

export const CreateCRMEvent = (api, data) => {
    return api.post(`/api/v1/Customer/createCRMEvent`, data)
}

export const GetCrmEvents = (api, custId, pageNumber, pageSize, type, dateFrom, dateTo) => {
    return api.get(`/api/v1/Customer/getCrmEvents`, {
        params: {
            custId: custId,
            pageNumber: pageNumber,
            pageSize: pageSize,
            type: type,
            dateFrom: dateFrom,
            dateTo: dateTo,
        }
    })
}

export const UpdateCRMEvent = (api, recNo, custId, type, theme, eventDateTime, evaluation, comments, name) => {
    let data = {
        custId,
        name,
        type,
        theme,
        eventDateTime,
        evaluation,
        comments,
        recno: recNo,
    }
    return api.post(`/api/v1/Customer/updateCRMEvent`, data)
}

export const GetCustomerDiscounts = (api) => {
    return api.get(`/api/v1/Customer/getCustomerDiscounts`)
}